const scrollToTop = () => {
  try {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    })
  } catch (e) {
    console.error(e)
  }
}

export default scrollToTop
